import { useEffect } from 'react';
import Client from '@/components/clients/client/Client';
import { Pocket } from '@/ui/Pocket';
import { lazyWithSuspense } from '@/shared/lazyWithSuspense';
import { preloadLazy } from '@/utils/preload-lazy';
import { canSeeShopFees } from '@/utils/funcs';

const GenericOrderModal = lazyWithSuspense(
	() => import('@/components/orders/generic-order-modal/GenericOrderModal'),
	null,
	null,
);
const FeeModal = lazyWithSuspense(() => import('@/components/orders/fee-modal/FeeModal'), null, null);

export const LiveModals = ({
	isMasterOrAdmin,
	isClientModalOpen,
	isEditClientModalOpen,
	isGenericOrderModalOpen,
	isCompleteOrderModalOpen,
	closeAllModals,
	selectedClient,
	clientSearchText,
	onCloseClientModal,
	onNewOrEditClient,
	editSelectedClient,
	onCloseEditClientModal,
	onSuccessClientEditCb,
	feeList,
	customFee,
	changeCustomFee,
	selectedFeeIdx,
	changeSelectedFeeIdx,
	customFeeSelected,
	completeOrder,
	onCloseCompleteModal,
	onCloseGenericOrderModal,
	onCancelOrder,
	openCompleteModal,
	onRemoveOrderDelivery,
	selectedGenericOrderId,
	activeOrders,
	areas,
	user,
	selectedShop,
	onEditLiveOrder,
	onChangeOrderDelay,
}) => {
	// This lazy component is created with no auto-preload, so whoever can open
	// the modal has to be preloaded here — including a shop that is allowed to
	// change the preparation time.
	const canOpenGenericOrderModal = isMasterOrAdmin || !!user?.allowChangeOrderDelay;
	useEffect(() => {
		if (canOpenGenericOrderModal) {
			preloadLazy(GenericOrderModal, 1000, 'genericmodal');
		}
	}, [canOpenGenericOrderModal]);

	return (
		<Pocket
			open={
				isClientModalOpen ||
				isEditClientModalOpen ||
				isGenericOrderModalOpen ||
				isCompleteOrderModalOpen
			}
			title={
				isClientModalOpen
					? 'Προβολή πελάτη'
					: isEditClientModalOpen
						? 'Προβολή πελάτη'
						: isGenericOrderModalOpen
							? 'Επιλογές παραγγελίας'
							: isCompleteOrderModalOpen
								? 'Ολοκλήρωση παραγγελίας'
								: ''
			}
			onOpenChange={closeAllModals}
			onClose={() => closeAllModals(false)}
		>
			{isClientModalOpen ? (
				<Client
					client={selectedClient}
					initPhone={clientSearchText}
					onClose={onCloseClientModal}
					onClientSelect={onNewOrEditClient}
				/>
			) : isEditClientModalOpen ? (
				<Client
					client={editSelectedClient}
					onClose={onCloseEditClientModal}
					onSuccessEditCb={onSuccessClientEditCb}
				/>
			) : isCompleteOrderModalOpen ? (
				<FeeModal
					title='Ολοκλήρωση παραγγελίας'
					onClose={onCloseCompleteModal}
					feeList={feeList}
					customFee={customFee}
					changeCustomFee={changeCustomFee}
					selectedFeeIdx={selectedFeeIdx}
					changeSelectedFeeIdx={changeSelectedFeeIdx}
					customFeeSelected={customFeeSelected}
					onSave={completeOrder}
					saveText='Ολοκλήρωση'
				/>
			) : isGenericOrderModalOpen ? (
				<GenericOrderModal
					title='Επιλογές παραγγελίας'
					onClose={onCloseGenericOrderModal}
					onCancelOrder={onCancelOrder}
					openCompleteModal={openCompleteModal}
					onRemoveOrderDelivery={onRemoveOrderDelivery}
					order={
						selectedGenericOrderId
							? activeOrders?.find?.(o => o.id === selectedGenericOrderId)
							: null
					}
					areas={areas}
					feeList={feeList}
					withFees={user?.cityLocation?.withFees}
					withShopFees={canSeeShopFees(user)}
					shop={selectedShop}
					onSave={onEditLiveOrder}
					onChangeDelay={onChangeOrderDelay}
					isMasterOrAdmin={isMasterOrAdmin}
				/>
			) : null}
		</Pocket>
	);
};
